/**
 * Formatação da nota do médico no painel.
 * Regra: média aritmética com 1 casa (vindo da API); sem avaliações → mensagem explícita.
 */

export function formatDoctorSatisfactionDisplay(
  satisfactionRating: number | null | undefined,
  ratingsCount: number | null | undefined,
): { value: string; hasRatings: boolean } {
  const count = Number(ratingsCount || 0);
  if (
    count <= 0 ||
    satisfactionRating === null ||
    satisfactionRating === undefined ||
    Number.isNaN(Number(satisfactionRating))
  ) {
    return { value: 'Sem avaliações', hasRatings: false };
  }

  const rounded = Number(Number(satisfactionRating).toFixed(1));
  return { value: `${rounded.toFixed(1)}/5.0`, hasRatings: true };
}
